var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup11648(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1022)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 98,
    height: 98,
    rx: 28,
    fill: "#37393F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.6862 78.9512C93.6862 79.7162 93.5162 80.5025 93.155 81.2675C92.7937 82.0325 92.3263 82.755 91.71 83.435C90.6688 84.5825 89.5212 85.4113 88.225 85.9425C86.95 86.4738 85.5688 86.75 84.0813 86.75C81.9138 86.75 79.5975 86.24 77.1537 85.1988C74.71 84.1575 72.2662 82.755 69.8438 80.9913C67.4 79.2063 65.0837 77.23 62.8737 75.0412C60.685 72.8312 58.7087 70.515 56.945 68.0925C55.2025 65.67 53.8 63.2475 52.78 60.8463C51.76 58.4238 51.25 56.1075 51.25 53.8975C51.25 52.4525 51.505 51.0713 52.015 49.7963C52.525 48.5 53.3325 47.31 54.4587 46.2475C55.8187 44.9088 57.3063 44.25 58.8788 44.25C59.4738 44.25 60.0688 44.3775 60.6 44.6325C61.1525 44.8875 61.6413 45.27 62.0238 45.8225L66.9538 52.7713C67.3363 53.3025 67.6125 53.7913 67.8037 54.2588C67.995 54.705 68.1013 55.1513 68.1013 55.555C68.1013 56.065 67.9525 56.575 67.655 57.0637C67.3788 57.5525 66.975 58.0625 66.465 58.5725L64.85 60.2512C64.6162 60.485 64.51 60.7613 64.51 61.1013C64.51 61.2713 64.5313 61.42 64.5738 61.59C64.6375 61.76 64.7013 61.8875 64.7438 62.015C65.1263 62.7162 65.785 63.63 66.72 64.735C67.6762 65.84 68.6962 66.9663 69.8012 68.0925C70.9487 69.2188 72.0537 70.26 73.18 71.2162C74.285 72.1512 75.1987 72.7887 75.9212 73.1712C76.0275 73.2137 76.155 73.2775 76.3037 73.3412C76.4737 73.405 76.6437 73.4262 76.835 73.4262C77.1962 73.4262 77.4725 73.2988 77.7062 73.065L79.3213 71.4713C79.8525 70.94 80.3625 70.5362 80.8513 70.2812C81.34 69.9837 81.8287 69.835 82.36 69.835C82.7637 69.835 83.1888 69.92 83.6562 70.1113C84.1237 70.3025 84.6125 70.5788 85.1438 70.94L92.1775 75.9337C92.73 76.3162 93.1125 76.7625 93.3462 77.2937C93.5587 77.825 93.6862 78.3562 93.6862 78.9512Z",
    stroke: "white",
    strokeWidth: 3.1875,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3125 59.125C86.3125 57.85 85.3137 55.895 83.8262 54.3013C82.4662 52.835 80.66 51.6875 78.875 51.6875",
    stroke: "white",
    strokeWidth: 3.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.75 59.125C93.75 50.9013 87.0987 44.25 78.875 44.25",
    stroke: "white",
    strokeWidth: 3.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1022",
    x: 0,
    y: 0,
    width: 146,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1022"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1022",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11648);
export default __webpack_public_path__ + "static/media/Group 11648.e7a3003f1145ef979a117ee24b356d2a.svg";
export { ForwardRef as ReactComponent };